import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class Card extends Component {
  hasImage () {
    return this.props.image && this.props.image.src
  }

  render () {
    const hasSubtitle = this.props.subtitle

    return (
      <div className="w-full">
        <Link to={this.props.url} className={classNames('relative pt-portrait block h-0 w-full bg-coral')}>
          {(this.hasImage()) && <img src={this.props.image.src} alt={this.props.image.alt || this.props.title} className={classNames('absolute w-full h-full block top-0 left-0 right-0 object-cover')} />}

          {this.props.badge && (
            <span className="rounded-1/2 bg-white absolute top-2 left-2 z-10 flex items-center justify-center text-xxs md:text-base-normal w-13 h-13 md:w-18 md:h-18 text-center">
              {this.props.badge}
            </span>
          )}
        </Link>

        <div className={classNames('mt-2 xxl:mt-6 relative')}>
          {hasSubtitle &&
          <span className="block text-xxs md:text-xs lg:text-base">
            {this.props.subtitle}
          </span>}

          <h3 className={`md:text-sm xl:text-md ${hasSubtitle ? 'mt-2 xxl:mt-4' : ''}`}>
            {this.props.title}
          </h3>

          {(this.props.colour || this.props.styleCode) && (
            <div className="text-xxs flex flex-wrap mt-2 xxl:mt-4 justify-between md:text-xs lg:text-base">
              <span className="w-auto">
                {this.props.colour}
              </span>

              <span className="w-auto">
                #
                {this.props.styleCode}
              </span>
            </div>
          )}
        </div>
      </div>
    )
  }
}

Card.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  badge: PropTypes.string,
  styleCode: PropTypes.string,
  colour: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  })
}

export default Card
